module.exports = __webpack_public_path__ + "img/icon-user-request-hover.abb2b61e.svg";